import { useMutation } from "@tanstack/react-query";
import { sendContactForm } from "@/api/endpoints/contactForm";

export function useSendContactForm() {
  return useMutation({
    mutationFn: sendContactForm,
  });
}
